import script from "./sms-verify.vue?vue&type=script&lang=ts&setup=true"
export * from "./sms-verify.vue?vue&type=script&lang=ts&setup=true"

import "./sms-verify.vue?vue&type=style&index=0&id=4cf4cb80&lang=scss"

const __exports__ = script;

export default __exports__